var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChestUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M0 0L0 1000L1000 1000L1000 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M458 205L458 206L461 206L458 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M461 205L461 206L464 206L461 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M464 205L464 206L467 206L464 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M411 575C410.073 586.643 406.493 602.88 398.471 611.79C394.242 616.487 387.357 619.187 382 622.4C370.083 629.546 358.018 636.45 346 643.424C329.296 653.119 312.777 663.155 296 672.719C287.375 677.636 275.367 682.382 268.419 689.529C263.123 694.976 261.5 706.82 259.629 714C254.354 734.236 243.811 762.965 248.483 783.995C250.492 793.038 263.943 790 271 790L343 790L576 790L639 790C645.479 790 658.132 792.419 663.772 788.972C668.423 786.129 667.708 777.692 668.285 773C670.3 756.594 670.286 739.293 667.196 723C664.978 711.306 661.474 698.302 653.482 689.104C646.809 681.424 634.664 676.598 626 671.4C605.725 659.235 585.304 647.318 565 635.201C552.336 627.643 534.777 612.522 520 611C521.221 605.526 517.436 601.863 515.338 597C512.323 590.011 510.371 580.489 512 573C522.822 576.199 535.778 575 547 575C572.462 575 597.85 573.447 623 569.247C630.649 567.97 652.375 566.359 656.958 559.49C660.276 554.517 654.136 538.683 653 533C648.155 508.774 643.541 484.477 640.13 460C635.151 424.265 637.089 387.148 630.196 352C616.779 283.59 570.522 215.107 497 206.286C456.764 201.458 416.869 211.816 381 229.753C367.104 236.702 351.035 244.822 340.09 256.039C318.985 277.668 306.246 308.388 297.721 337C286.837 373.528 291.363 408.878 287.83 446C285.181 473.841 282.472 501.619 276.424 529C275.213 534.483 266.881 552.991 270.643 557.298C276.971 564.541 296.938 567.059 306 569C341.585 576.622 375.093 575.297 411 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M487 205L487 206L490 206L487 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M490.667 205.333L491.333 205.667L490.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M492 205L492 206L495 206L492 205M450.667 206.333L451.333 206.667L450.667 206.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M452 206L453 207L452 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M453.667 206.333L454.333 206.667L453.667 206.333M498.667 206.333L499.333 206.667L498.667 206.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M500 206L501 207L500 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M501.667 206.333L502.333 206.667L501.667 206.333M444 207L445 208L444 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M445.667 207.333L446.333 207.667L445.667 207.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M447 207L448 208L447 207M505 207L506 208L505 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M506 207L507 208L506 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M507.667 207.333L508.333 207.667L507.667 207.333M438.667 208.333L439.333 208.667L438.667 208.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M440 208L441 209L440 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M441 208L442 209L441 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M511 208L512 209L511 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M512.667 208.333L513.333 208.667L512.667 208.333M434 209L435 210L434 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M435 209L436 210L435 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M436 209L437 210L436 209M515 209L516 210L515 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M516 209L517 210L516 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M517 209L518 210L517 209M430 210L431 211L430 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M431 210L432 211L431 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M432 210L433 211L432 210M519 210L520 211L519 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M520 210L521 211L520 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M521 210L522 211L521 210M426 211L427 212L426 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M427 211L428 212L427 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M428 211L429 212L428 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M523 211L524 212L523 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M524 211L525 212L524 211M422.667 212.333L423.333 212.667L422.667 212.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M424 212L425 213L424 212M526 212L527 213L526 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M527 212L528 213L527 212M419 213L420 214L419 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M420 213L421 214L420 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M529 213L530 214L529 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M530 213L531 214L530 213M416 214L417 215L416 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M417 214L418 215L417 214M532 214L533 215L532 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M533 214L534 215L533 214M413 215L414 216L413 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M414 215L415 216L414 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M534 215L535 216L534 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M535 215L536 216L535 215M410 216L411 217L410 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M411 216L412 217L411 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M537 216L538 217L537 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M538 216L539 217L538 216M407 217L408 218L407 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M408 217L409 218L408 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M539 217L540 218L539 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M540 217L541 218L540 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M405 218L406 219L405 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M406 218L407 219L406 218M541 218L542 219L541 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M542 218L543 219L542 218M402 219L403 220L402 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M403 219L404 220L403 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M543 219L544 220L543 219M400 220L401 221L400 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M545 220L546 221L545 220M397 221L398 222L397 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M398 221L399 222L398 221M546 221L547 222L546 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M395 222L396 223L395 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M396 222L397 223L396 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M548 222L549 223L548 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M393 223L394 224L393 223M549 223L550 224L549 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M390 224L391 225L390 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M391 224L392 225L391 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M551 224L552 225L551 224M388 225L389 226L388 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M389 225L390 226L389 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M552 225L553 226L552 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M386 226L387 227L386 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M387 226L388 227L387 226M553 226L554 227L553 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M384 227L385 228L384 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M385 227L386 228L385 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M555 227L556 228L555 227M382 228L383 229L382 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M383 228L384 229L383 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M556 228L557 229L556 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M380 229L381 230L380 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M381 229L382 230L381 229M557 229L558 230L557 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M378 230L379 231L378 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M379 230L380 231L379 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M559 230L560 231L559 230M376 231L377 232L376 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M377 231L378 232L377 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M560 231L561 232L560 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M375 232L376 233L375 232M561 232L562 233L561 232M373 233L374 234L373 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M562 233L563 234L562 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M371 234L372 235L371 234M564 234L565 235L564 234M369 235L370 236L369 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 235L371 236L370 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M565 235L566 236L565 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M368 236L369 237L368 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M566 236L567 237L566 236M366 237L367 238L366 237M567 237L568 238L567 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M364 238L365 239L364 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M365 238L366 239L365 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M568 238L569 239L568 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M363 239L364 240L363 239M569 239L570 240L569 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M361 240L362 241L361 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M570 240L571 241L570 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M359 241L360 242L359 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M360 241L361 242L360 241M571 241L572 242L571 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M358 242L359 243L358 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M572 242L573 243L572 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M356 243L357 244L356 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M573 243L574 244L573 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M355 244L356 245L355 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M574 244L575 245L574 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M353 245L354 246L353 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M575 245L576 246L575 245M352 246L353 247L352 246M576 246L577 247L576 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M350 247L351 248L350 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M577 247L578 248L577 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M349 248L350 249L349 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M578 248L579 249L578 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M347 249L348 250L347 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M579 249L580 250L579 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M346 250L347 251L346 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M580 250L581 251L580 250M345 251L346 252L345 251M581 251L582 252L581 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M343 252L344 253L343 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M582 252L583 253L582 252M342 253L343 254L342 253M583 253L584 254L583 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M341 254L342 255L341 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M584 254L585 255L584 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M340 255L341 256L340 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M585 255L586 256L585 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M339 256L340 257L339 256M338 257L339 258L338 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M586 257L587 258L586 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M337 258L338 259L337 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M587 258L588 259L587 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M336 259L334 262L336 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M588 259L589 260L588 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M336 260L337 261L336 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M589 260L590 261L589 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M335 261L336 262L335 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M590 261L591 262L590 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M334 262L335 263L334 262M590 262L591 263L590 262M333 263L334 264L333 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M591 263L592 264L591 263M332 264L333 265L332 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M592 264L593 265L592 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M331 265L332 266L331 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M593 265L594 266L593 265M330 266L329 268L330 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M593 266L594 267L593 266M330 267L331 268L330 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M594 267L595 268L594 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M329 268L330 269L329 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M595 268L596 269L595 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M328 269L329 270L328 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M327 270L328 271L327 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M596 270L597 271L596 270M327 271L328 272L327 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M597 271L598 272L597 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M326 272L327 273L326 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M325 273L326 274L325 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M598 273L599 274L598 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M599 274L600 275L599 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M324 275L325 276L324 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M323 276L324 277L323 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M600 276L601 277L600 276M323 277L324 278L323 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M601 277L602 278L601 277M322 278L323 279L322 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M322 279L323 280L322 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M602 279L603 280L602 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M321 280L322 281L321 280M603 280L604 281L603 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M603 281L604 282L603 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M320 282L321 283L320 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M604 282L605 283L604 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M319 284L320 285L319 284M605 284L606 285L605 284M318 286L319 287L318 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M606 286L607 287L606 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M317 287L318 288L317 287M607 287L608 288L607 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M317 288L318 289L317 288M607 288L608 289L607 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M316 289L317 290L316 289M608 289L609 290L608 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M316 290L317 291L316 290M608 290L609 291L608 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M315 291L316 292L315 291M609 291L610 292L609 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M315 292L316 293L315 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M314 293L315 294L314 293M610 293L611 294L610 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M314 294L315 295L314 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M313 295L314 296L313 295M611 295L612 296L611 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M313 296L314 297L313 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M312 297L313 298L312 297M612 297L613 298L612 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M312 298L313 299L312 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M612 298L613 299L612 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M613 299L614 300L613 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M311 300L312 301L311 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M613 300L614 301L613 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M614 301L615 302L614 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M310 302L311 303L310 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M614 302L615 303L614 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M615 303L616 304L615 303M309 304L310 305L309 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M615 304L616 305L615 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M309 305L310 306L309 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M308 306L309 307L308 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M616 306L617 307L616 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 307L309 308L308 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M617 308L618 309L617 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M307 309L308 310L307 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M617 309L618 310L617 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M618 310L619 311L618 310M306 311L307 312L306 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M618 311L619 312L618 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M306 312L307 313L306 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M305 313L306 314L305 313M619 313L620 314L619 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M305 314L306 315L305 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M619 314L620 315L619 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M304 316L305 317L304 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M620 316L621 317L620 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M304 317L305 318L304 317M620 317L621 318L620 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M621 318L622 319L621 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M303 319L304 320L303 319M621 319L622 320L621 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M302 321L303 322L302 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M463.667 321.333L464.333 321.667L463.667 321.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M622 321L623 322L622 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M302 322L303 323L302 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M463.667 322.333L464.333 322.667L463.667 322.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 322L623 323L622 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M463 323C460.001 335.964 454.293 348.42 450.003 361C448.493 365.429 447.22 373.03 443.49 376.142C439.404 379.551 430.946 378 426 378C407.634 378 390.945 372.573 374 366C362.156 417.663 356.87 470.62 386.425 518C410.246 556.188 461.311 573.667 503 552.865C523.772 542.5 540.912 521.012 551.691 501C573.482 460.539 563 415.54 563 372C546.02 376.183 527.445 378.028 510 378C503.48 377.99 494.168 377.987 489.418 372.775C477.898 360.135 477.429 332.452 463 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M465 323L466 324L465 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M301 324L302 325L301 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M462 324L463 325L462 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M465 324L466 325L465 324M623 324L624 325L623 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M301 325L302 326L301 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M462 325L463 326L462 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M466 325L467 326L466 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623 325L624 326L623 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M466 326L467 327L466 326M300 327L301 328L300 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M461 327L462 328L461 327M467 327L468 328L467 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M624 327L625 328L624 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M300 328L301 329L300 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M461 328L462 329L461 328M467 328L468 329L467 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M624 328L625 329L624 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M468 329L469 330L468 329M624 329L625 330L624 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M299 330L300 331L299 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M460 330L461 331L460 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M468 330L469 331L468 330M625.333 330.667L625.667 331.333L625.333 330.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M299 331L300 332L299 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M460 331L461 332L460 331M469 332L470 333L469 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M625 332L626 333L625 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M298 333L299 334L298 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M459 333L460 334L459 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M298 334L299 335L298 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M459 334L460 335L459 334M470 334L471 335L470 334M626 334L627 335L626 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M458 335L459 336L458 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M626 335L627 336L626 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M297 336L298 337L297 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M458 336L459 337L458 336M471 336L472 337L471 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M626 336L627 337L626 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M297 337L298 338L297 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M458 337L459 338L458 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M457 338L458 339L457 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M472 338L473 339L472 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M627 338L628 339L627 338M296 339L297 340L296 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M457 339L458 340L457 339M627 339L628 340L627 339M296 340L297 341L296 340M473 340L474 341L473 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M296 341L297 342L296 341M456 341L457 342L456 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M456 342L457 343L456 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M474 342L475 343L474 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M628 342L629 343L628 342M295 343L296 344L295 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M628 343L629 344L628 343M295 344L296 345L295 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M455 344L456 345L455 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M475 344L476 345L475 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M628 344L629 345L628 344M295 345L296 346L295 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M455 345L456 346L455 345M475 345L476 346L475 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M476 346L477 347L476 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M629 346L630 347L629 346M294 347L295 348L294 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M454 347L455 348L454 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M476 347L477 348L476 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M629 347L630 348L629 347M294 348L295 349L294 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M454 348L455 349L454 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M477 348L478 349L477 348M629 348L630 349L629 348M294 349L295 350L294 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M477 349L478 350L477 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M453 350L454 351L453 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M478 350L479 351L478 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M293 351L294 352L293 351M453 351L454 352L453 351M478 351L479 352L478 351M630 351L631 352L630 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M293 352L294 353L293 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M479 352L480 353L479 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M630 352L631 353L630 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M293 353L294 354L293 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M452 353L453 354L452 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M479 353L480 354L479 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M630 353L631 354L630 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M452 354L453 355L452 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M480 354L481 355L480 354M451 355L452 356L451 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M480 355L481 356L480 355M292 356L293 357L292 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M451 356L452 357L451 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M481 356L482 357L481 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M631 356L632 357L631 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M292 357L293 358L292 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M481 357L482 358L481 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M631.333 357.667L631.667 358.333L631.333 357.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M292 358L293 359L292 358M450 358L451 359L450 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M450 359L451 360L450 359M482 359L483 360L482 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M631 359L632 360L631 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M291.333 360.667L291.667 361.333L291.333 360.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M449 361L450 362L449 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M483 361L484 362L483 361M291 362L292 363L291 362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M449 362L450 363L449 362M632.333 362.667L632.667 363.333L632.333 362.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M291 363L292 364L291 363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M484 363L485 364L484 363M448 364L449 365L448 364M632.333 364.667L632.667 365.333L632.333 364.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M448 365L449 366L448 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M485 365L486 366L485 365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M290.333 366.667L290.667 367.333L290.333 366.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M373 366L374 367L373 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M375 366L376 367L375 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M376 366L377 367L376 366M632 366L633 367L632 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M373 367L374 368L373 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M377 367L378 368L377 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 367L379 368L378 367M447 367L448 368L447 367M486 367L487 368L486 367M290.333 368.667L290.667 369.333L290.333 368.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M373 368L374 369L373 368M380 368L381 369L380 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M381 368L382 369L381 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M447 368L448 369L447 368M382 369L383 370L382 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M383 369L384 370L383 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M446 369L447 370L446 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M487 369L488 370L487 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M633 369L633 372L634 372L633 369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M290 370L291 371L290 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M372 370L373 371L372 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M385 370L386 371L385 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M386 370L387 371L386 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M446 370L447 371L446 370M487 370L488 371L487 370M372 371L373 372L372 371M388 371L389 372L388 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M389 371L390 372L389 371M488 371L489 372L488 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M391 372L392 373L391 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M392 372L393 373L392 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M445 372L446 373L445 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M488 372L489 373L488 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M557.667 372.333L558.333 372.667L557.667 372.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M559 372L560 373L559 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M560.667 372.333L561.333 372.667L560.667 372.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M633 372L633 375L634 375L633 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M289 373L289 376L290 376L289 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M371 373L372 374L371 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M394.667 373.333L395.333 373.667L394.667 373.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M396 373L397 374L396 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M445 373L446 374L445 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M489 373L490 374L489 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M551 373L552 374L551 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M552.667 373.333L553.333 373.667L552.667 373.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M554.667 373.333L555.333 373.667L554.667 373.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M371 374L372 375L371 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M398 374L399 375L398 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M399 374L400 375L399 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M400 374L401 375L400 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M490 374L491 375L490 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M545 374L546 375L545 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M546.667 374.333L547.333 374.667L546.667 374.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M548 374L549 375L548 374M371 375L372 376L371 375M402.667 375.333L403.333 375.667L402.667 375.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M404 375L405 376L404 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M405 375L406 376L405 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M444 375L445 376L444 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M492 375L493 376L492 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M493 375L494 376L493 375M537.667 375.333L538.333 375.667L537.667 375.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M539 375L540 376L539 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M540 375L540 376L543 376L540 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M633.333 375.667L633.667 376.333L633.333 375.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M289.333 376.667L289.667 377.333L289.333 376.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M408 376L409 377L408 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M409.667 376.333L410.333 376.667L409.667 376.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M411 376L412 377L411 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M444 376L445 377L444 376M495 376L496 377L495 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M496 376L497 377L496 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M497 376L498 377L497 376M528.667 376.333L529.333 376.667L528.667 376.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M530.667 376.333L531.333 376.667L530.667 376.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M532 376L532 377L535 377L532 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 377L371 378L370 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M414 377L414 378L418 378L414 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M418.667 377.333L419.333 377.667L418.667 377.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M420 377L420 378L424 378L420 377M433 377L433 378L437 378L433 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M437.667 377.333L438.333 377.667L437.667 377.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M439 377L439 378L442 378L439 377M501 377L501 378L504 378L501 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M504 377L504 378L507 378L504 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M507 377L507 378L515 378L507 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M515 377L515 378L520 378L515 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M520 377L520 378L524 378L520 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M289 378L290 379L289 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M370.333 378.667L370.667 379.333L370.333 378.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M563 379L563 382L564 382L563 379M633 380L633 393L634 393L633 380M369 381L370 382L369 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M369 382L370 383L369 382M563 382L563 385L564 385L563 382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M288 383L288 387L289 387L288 383M369 383L370 384L369 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M368 385L369 386L368 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M563 385L563 389L564 389L563 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M368 386L369 387L368 386M288 387L288 391L289 391L288 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M368 387L369 388L368 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M367 390L368 391L367 390M288 391L288 397L289 397L288 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M367 391L368 392L367 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M367 392L368 393L367 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M564 393L564 396L565 396L564 393M366 395L367 396L366 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M366 396L367 397L366 396M564 396L564 399L565 399L564 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M366.333 397.667L366.667 398.333L366.333 397.667M564 399L564 404L565 404L564 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M365 401L366 402L365 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M634 401L634 406L635 406L634 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M365.333 402.667L365.667 403.333L365.333 402.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M365.333 404.667L365.667 405.333L365.333 404.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M288 405L288 410L289 410L288 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M634 406L634 409L635 409L634 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M364.333 408.667L364.667 409.333L364.333 408.667M634 409L634 412L635 412L634 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 410L288 413L289 413L288 410M364.333 410.667L364.667 411.333L364.333 410.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M565 410L565 413L566 413L565 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M364 412L364 415L365 415L364 412M288 413L288 418L289 418L288 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M565 413L565 418L566 418L565 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M635 416L635 419L636 419L635 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M363 418L363 421L364 421L363 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M565 418L565 428L566 428L565 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M635.333 419.667L635.667 420.333L635.333 419.667M363 421L363 425L364 425L363 421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M635.333 421.667L635.667 422.333L635.333 421.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M288 423L288 428L289 428L288 423M363 425L363 441L364 441L363 425M636 426L636 429L637 429L636 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 428L288 432L289 432L288 428M636.333 429.667L636.667 430.333L636.333 429.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M636.333 431.667L636.667 432.333L636.333 431.667M288 432L288 435L289 435L288 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M637 435L637 438L638 438L637 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M637.333 438.667L637.667 439.333L637.333 438.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M287 439L287 444L288 444L287 439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M637 440L638 441L637 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M363 441L363 445L364 445L363 441M287 444L287 447L288 447L287 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M638.333 444.667L638.667 445.333L638.333 444.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M363.333 445.667L363.667 446.333L363.333 445.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M565 445L565 452L566 452L565 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M638.333 446.667L638.667 447.333L638.333 446.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M287.333 447.667L287.667 448.333L287.333 447.667M638 448L639 449L638 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M364 450L364 454L365 454L364 450M639 451L639 454L640 454L639 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M565 452L565 455L566 455L565 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M286 453L286 457L287 457L286 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M364 454L365 455L364 454M639 454L640 455L639 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M364.333 455.667L364.667 456.333L364.333 455.667M565.333 455.667L565.667 456.333L565.333 455.667M639 455L640 456L639 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M286.333 457.667L286.667 458.333L286.333 457.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M640.333 458.667L640.667 459.333L640.333 458.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M286.333 459.667L286.667 460.333L286.333 459.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M365.333 459.667L365.667 460.333L365.333 459.667M564 460L564 463L565 463L564 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M640.333 460.667L640.667 461.333L640.333 460.667M365 461L366 462L365 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M365 462L366 463L365 462M640 462L641 463L640 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M564 463L565 464L564 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M285 464L285 467L286 467L285 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M564 464L565 465L564 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M366.333 465.667L366.667 466.333L366.333 465.667M641.333 465.667L641.667 466.333L641.333 465.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M285.333 467.667L285.667 468.333L285.333 467.667M366 467L367 468L366 467M641.333 467.667L641.667 468.333L641.333 467.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M366 468L367 469L366 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M563.333 468.667L563.667 469.333L563.333 468.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M285.333 469.667L285.667 470.333L285.333 469.667M641 469L642 470L641 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M367 470L368 471L367 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M563 470L564 471L563 470M367 471L368 472L367 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M367 472L368 473L367 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M642.333 472.667L642.667 473.333L642.333 472.667M562 473L563 474L562 473M284 474L284 477L285 477L284 474M368 474L369 475L368 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M562 474L563 475L562 474M642 474L643 475L642 474M368 475L369 476L368 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M642 475L643 476L642 475M368 476L369 477L368 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M561 476L562 477L561 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M284.333 477.667L284.667 478.333L284.333 477.667M561 477L562 478L561 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M369 478L370 479L369 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M561 478L562 479L561 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M643.333 478.667L643.667 479.333L643.333 478.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M284 479L285 480L284 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M369 479L370 480L369 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M560 479L561 480L560 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M369 480L370 481L369 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M560 480L561 481L560 480M643 480L644 481L643 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M643 481L644 482L643 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M370 482L371 483L370 482M559 482L560 483L559 482M283.333 483.667L283.667 484.333L283.333 483.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M370 483L371 484L370 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M559 483L560 484L559 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M644.333 484.667L644.667 485.333L644.333 484.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M283.333 485.667L283.667 486.333L283.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M371 485L372 486L371 485M558 485L559 486L558 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M371 486L372 487L371 486M558 486L559 487L558 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M644 486L645 487L644 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M283 487L284 488L283 487M644 487L645 488L644 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M372 488L373 489L372 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M557 488L558 489L557 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M372 489L373 490L372 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M556 490L557 491L556 490M645.333 490.667L645.667 491.333L645.333 490.667M282.333 491.667L282.667 492.333L282.333 491.667M373 491L374 492L373 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M556 491L557 492L556 491M373 492L374 493L373 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M555 492L556 493L555 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M645 492L646 493L645 492M282.333 493.667L282.667 494.333L282.333 493.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M374 493L375 494L374 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M555 493L556 494L555 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M645 493L646 494L645 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M374 494L375 495L374 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M282 495L283 496L282 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M554 495L555 496L554 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M375 496L376 497L375 496M646.333 496.667L646.667 497.333L646.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M375 497L376 498L375 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M553 497L554 498L553 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M281.333 498.667L281.667 499.333L281.333 498.667M376 498L377 499L376 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M646 498L647 499L646 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M376 499L377 500L376 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M552 499L553 500L552 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M646 499L647 500L646 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M281 500L282 501L281 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M281.333 501.667L281.667 502.333L281.333 501.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M377 501L378 502L377 501M551 501L552 502L551 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M647.333 501.667L647.667 502.333L647.333 501.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M378 503L379 504L378 503M550 503L551 504L550 503M647 503L648 504L647 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M549 504L550 505L549 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M647 504L648 505L647 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M280.333 505.667L280.667 506.333L280.333 505.667M379 505L380 506L379 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M549 505L550 506L549 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M548 506L549 507L548 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M280 507L281 508L280 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M380 507L381 508L380 507M648 507L649 508L648 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M280 508L281 509L280 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M547 508L548 509L547 508M648.333 508.667L648.667 509.333L648.333 508.667M381 509L382 510L381 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M546 509L547 510L546 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M546 510L547 511L546 510M648 510L649 511L648 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M279 511L280 512L279 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M382 511L383 512L382 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M545 511L546 512L545 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M279.333 512.667L279.667 513.333L279.333 512.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M649.333 512.667L649.667 513.333L649.333 512.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M383 513L384 514L383 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M544 513L545 514L544 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M279 514L280 515L279 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M384 514L385 515L384 514M543 514L544 515L543 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M649 514L650 515L649 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M384 515L385 516L384 515M649 515L650 516L649 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M278.333 516.667L278.667 517.333L278.333 516.667M385 516L386 517L385 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M542 516L543 517L542 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M541 517L542 518L541 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M278 518L279 519L278 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M386 518L387 519L386 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M650 518L651 519L650 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M278 519L279 520L278 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M387 519L388 520L387 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M540 519L541 520L540 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M650 519L651 520L650 519M539 520L540 521L539 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M650 520L651 521L650 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M277.333 521.667L277.667 522.333L277.333 521.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M388 521L389 522L388 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M538 521L539 522L538 521M389 522L390 523L389 522M537 522L538 523L537 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M277 523L278 524L277 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M537 523L538 524L537 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M651 523L652 524L651 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M277 524L278 525L277 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M390 524L391 525L390 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M536 524L537 525L536 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M651 524L652 525L651 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M391 525L392 526L391 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M535 525L536 526L535 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M651 525L652 526L651 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M276.333 526.667L276.667 527.333L276.333 526.667M392 526L393 527L392 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M534 526L535 527L534 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M392 527L393 528L392 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M533 527L534 528L533 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M276 528L277 529L276 528M393 528L394 529L393 528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M532 528L533 529L532 528M652 528L653 529L652 528M394 529L395 530L394 529M531 529L532 530L531 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M652 529L653 530L652 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M395 530L396 531L395 530M530 530L531 531L530 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M652 530L653 531L652 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M275 531L276 532L275 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M395 531L396 532L395 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 532L276 533L275 532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M396 532L397 533L396 532M275 533L276 534L275 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M397 533L398 534L397 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M527 533L528 534L527 533M653 533L654 534L653 533M398 534L399 535L398 534M526 534L527 535L526 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M653 534L654 535L653 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M274 535L275 536L274 535M399 535L400 536L399 535M525 535L526 536L525 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M653 535L654 536L653 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M274 536L275 537L274 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M400 536L401 537L400 536M524 536L525 537L524 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M274 537L275 538L274 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M523 537L524 538L523 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M401 538L402 539L401 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M522 538L523 539L522 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M654 538L655 539L654 538M273 539L274 540L273 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M402 539L403 540L402 539M521 539L522 540L521 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M654 539L655 540L654 539M273 540L274 541L273 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M403 540L404 541L403 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M519 540L520 541L519 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M520 540L521 541L520 540M654 540L655 541L654 540M404 541L405 542L404 541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M518 541L519 542L518 541M272.333 542.667L272.667 543.333L272.333 542.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M405 542L406 543L405 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M517 542L518 543L517 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M407 543L408 544L407 543M515 543L516 544L515 543M655 543L656 544L655 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M272 544L273 545L272 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M408 544L409 545L408 544M513 544L512 546L513 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M514 544L515 545L514 544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M655 544L656 545L655 544M409 545L410 546L409 545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M513 545L514 546L513 545M655 545L656 546L655 545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M271 546L272 547L271 546M411 546L412 547L411 546M511 546L512 547L511 546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M271 547L272 548L271 547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M412 547L413 548L412 547M510 547L511 548L510 547M656.333 547.667L656.667 548.333L656.333 547.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M413 548L414 549L413 548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M509 548L510 549L509 548M270 549L271 550L270 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M414 549L415 550L414 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M415 549L415 550L418 550L415 549M508 549L509 550L508 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M656 549L657 550L656 549M270 550L271 551L270 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M417 550L418 551L417 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M418 550L419 551L418 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M419 550L420 551L419 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M507 550L508 551L507 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M656 550L657 551L656 550M420 551L421 552L420 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M421 551L422 552L421 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M422 551L423 552L422 551M505 551L506 552L505 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M506 551L507 552L506 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M269 552L270 553L269 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M423 552L424 553L423 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M424 552L425 553L424 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M425 552L426 553L425 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M504 552L505 553L504 552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M657.333 552.667L657.667 553.333L657.333 552.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M269 553L270 554L269 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M426 553L427 554L426 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M427.667 553.333L428.333 553.667L427.667 553.333M501 553L502 554L501 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M502 553L503 554L502 553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M503 553L504 554L503 553M429 554L430 555L429 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M430.667 554.333L431.333 554.667L430.667 554.333M499 554L500 555L499 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M500 554L501 555L500 554M657 554L658 555L657 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M268 555L269 556L268 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M432 555L433 556L432 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M433.667 555.333L434.333 555.667L433.667 555.333M496 555L497 556L496 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M497 555L498 556L497 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M498 555L499 556L498 555M268 556L269 557L268 556M434 556L435 557L434 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M435 556L436 557L435 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M436 556L437 557L436 556M493 556L494 557L493 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M494 556L495 557L494 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M495 556L496 557L495 556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M268 557L269 558L268 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M269 557L270 558L269 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M438 557L439 558L438 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M439.667 557.333L440.333 557.667L439.667 557.333M490.667 557.333L491.333 557.667L490.667 557.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M492 557L493 558L492 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M658 557L659 558L658 557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M271 558L272 559L271 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M441 558L442 559L441 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M442.667 558.333L443.333 558.667L442.667 558.333M486.667 558.333L487.333 558.667L486.667 558.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M488 558L489 559L488 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M489 558L490 559L489 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M658 558L659 559L658 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M273 559L274 560L273 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M274 559L275 560L274 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M420.667 559.333L421.333 559.667L420.667 559.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M422 559L423 560L422 559M443 559L444 560L443 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M444 559L445 560L444 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M445.667 559.333L446.333 559.667L445.667 559.333M482.667 559.333L483.333 559.667L482.667 559.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M484 559L485 560L484 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M485 559L486 560L485 559M658 559L659 560L658 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M276 560L277 561L276 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M277 560L278 561L277 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M420.333 560.667L420.667 561.333L420.333 560.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M421 560L413.329 599L407.418 616L422 632L464 672L500.09 632L517 612C502.824 599.508 504 579.22 504 562C487.068 565.917 471.807 571.74 454 569.826C442.613 568.603 432.092 562.566 421 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M423 560L424 561L423 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M424 560L425 561L424 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M425 560L426 561L425 560M447 560L448 561L447 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M448 560L449 561L448 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M449 560L450 561L449 560M477 560L477 561L480 561L477 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M480 560L481 561L480 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M481 560L482 561L481 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M657 560L658 561L657 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M278 561L279 562L278 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M279 561L280 562L279 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M426 561L427 562L426 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M427 561L428 562L427 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M428 561L429 562L428 561M450 561L451 562L450 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M451 561L452 562L451 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M452.667 561.333L453.333 561.667L452.667 561.333M472.667 561.333L473.333 561.667L472.667 561.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M474 561L475 562L474 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M475.667 561.333L476.333 561.667L475.667 561.333M502 561L503 562L502 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M503 561L504 562L503 561M654 561L655 562L654 561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M655 561L656 562L655 561M281 562L282 563L281 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M282 562L283 563L282 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M429 562L430 563L429 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M430 562L431 563L430 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M431 562L432 563L431 562M454 562L454 563L457 563L454 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M457 562L457 563L465 563L457 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M465 562L465 563L471 563L465 562M499 562L500 563L499 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M500.667 562.333L501.333 562.667L500.667 562.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M651 562L652 563L651 562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M652 562L653 563L652 562M284 563L285 564L284 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M285 563L286 564L285 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M419 563L419 566L420 566L419 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M432 563L433 564L432 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M433 563L434 564L433 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M496 563L497 564L496 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M497 563L498 564L497 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M498 563L499 564L498 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M648 563L649 564L648 563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M649 563L650 564L649 563M287 564L288 565L287 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 564L289 565L288 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M435 564L436 565L435 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M436 564L437 565L436 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M437 564L438 565L437 564M493 564L494 565L493 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M494 564L495 565L494 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M495 564L496 565L495 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M644 564L645 565L644 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M645 564L646 565L645 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M646 564L647 565L646 564M290 565L291 566L290 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M291 565L292 566L291 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M292 565L293 566L292 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M438 565L439 566L438 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M439 565L440 566L439 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M440 565L441 566L440 565M489 565L490 566L489 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M490 565L491 566L490 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M491.667 565.333L492.333 565.667L491.667 565.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M640 565L641 566L640 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M641 565L642 566L641 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M642 565L643 566L642 565M294 566L295 567L294 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M295 566L296 567L295 566M419.333 566.667L419.667 567.333L419.333 566.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M440.667 566.333L441.333 566.667L440.667 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M442 566L443 567L442 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M443 566L444 567L443 566M485 566L486 567L485 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M486 566L487 567L486 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M487.667 566.333L488.333 566.667L487.667 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M636 566L637 567L636 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M637 566L638 567L637 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M638 566L639 567L638 566M298 567L299 568L298 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M299 567L300 568L299 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M444 567L445 568L444 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M445 567L446 568L445 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M446 567L447 568L446 567M481 567L482 568L481 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M482 567L483 568L482 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M483.667 567.333L484.333 567.667L483.667 567.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M632 567L633 568L632 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M633 567L634 568L633 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M634 567L635 568L634 567M301.667 568.333L302.333 568.667L301.667 568.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M303 568L304 569L303 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M419 568L419 571L420 571L419 568M447.667 568.333L448.333 568.667L447.667 568.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M449.667 568.333L450.333 568.667L449.667 568.333M476 568L477 569L476 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M477 568L478 569L477 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M478 568L478 569L481 569L478 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M627 568L628 569L627 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M628 568L629 569L628 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M629 568L630 569L629 568M306 569L307 570L306 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M307 569L308 570L307 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 569L309 570L308 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M451.667 569.333L452.333 569.667L451.667 569.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M453 569L454 570L453 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M454.667 569.333L455.333 569.667L454.667 569.333M465 569L465 570L471 570L465 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M471.667 569.333L472.333 569.667L471.667 569.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M473.667 569.333L474.333 569.667L473.667 569.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M621 569L622 570L621 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M622 569L623 570L622 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M623.667 569.333L624.333 569.667L623.667 569.333M310.667 570.333L311.333 570.667L310.667 570.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M312 570L313 571L312 570M615 570L616 571L615 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M616 570L617 571L616 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M617.667 570.333L618.333 570.667L617.667 570.333M315.667 571.333L316.333 571.667L315.667 571.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M317 571L318 572L317 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M318 571L319 572L318 571M607.667 571.333L608.333 571.667L607.667 571.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M609.667 571.333L610.333 571.667L609.667 571.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M611.667 571.333L612.333 571.667L611.667 571.333M320.667 572.333L321.333 572.667L320.667 572.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M322 572L323 573L322 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M323.667 572.333L324.333 572.667L323.667 572.333M418.333 572.667L418.667 573.333L418.333 572.667M599 572L600 573L599 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M600.667 572.333L601.333 572.667L600.667 572.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M602 572L602 573L605 573L602 572M327 573L328 574L327 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M328.667 573.333L329.333 573.667L328.667 573.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M330 573L331 574L330 573M512 573L513 574L512 573M587 573L587 574L590 574L587 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M590.667 573.333L591.333 573.667L590.667 573.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M592 573L592 574L596 574L592 573M333 574L333 575L336 575L333 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M336 574L337 575L336 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M337.667 574.333L338.333 574.667L337.667 574.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M418 574L419 575L418 574M511 574L512 575L511 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M515 574L515 575L519 575L515 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M519 574L519 575L522 575L519 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M522 574L522 575L525 575L522 574M571 574L571 575L575 575L571 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M575 574L575 575L578 575L575 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M578 574L578 575L583 575L578 574M342 575L342 576L345 576L342 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M345.667 575.333L346.333 575.667L345.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M347 575L347 576L350 576L347 575M403.667 575.333L404.333 575.667L403.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M405.667 575.333L406.333 575.667L405.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M407 575L407 576L411 577L407 575M418 575L418 578L419 578L418 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M504 575L504 580L505 580L504 575M511 575L511 580L512 580L511 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M533 575L533 576L562 576L533 575M354 576L354 577L359 577L354 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M359 576L359 577L363 577L359 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M363 576L363 577L370 577L363 576M380 576L380 577L388 577L380 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M388 576L388 577L393 577L388 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M393 576L393 577L398 577L393 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M410 577L411 578L410 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M410.333 578.667L410.667 579.333L410.333 578.667M417 579L418 580L417 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M409.333 580.667L409.667 581.333L409.333 580.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M417 580L418 581L417 580M504.333 580.667L504.667 581.333L504.333 580.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M417 581L417 584L418 584L417 581M512 581L512 584L513 584L512 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M409 582L410 583L409 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M504 582L504 585L505 585L504 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M409.333 583.667L409.667 584.333L409.333 583.667M416 584L417 585L416 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M512.333 584.667L512.667 585.333L512.333 584.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M408.333 585.667L408.667 586.333L408.333 585.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M416 585L417 586L416 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M416.333 586.667L416.667 587.333L416.333 586.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M505.333 586.667L505.667 587.333L505.333 586.667M512.333 586.667L512.667 587.333L512.333 586.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M408 587L409 588L408 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M408 588L409 589L408 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M505 588L506 589L505 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M513.333 588.667L513.667 589.333L513.333 588.667M407.333 589.667L407.667 590.333L407.333 589.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M415 589L416 590L415 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M505.333 589.667L505.667 590.333L505.333 589.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M415 590L416 591L415 590M513 590L514 591L513 590M407 591L408 592L407 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M415 591L416 592L415 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M513 591L514 592L513 591M407 592L408 593L407 592M506 592L507 593L506 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M514.333 592.667L514.667 593.333L514.333 592.667M406 593L407 594L406 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M414 593L415 594L414 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M506 593L507 594L506 593M406 594L407 595L406 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M414.333 594.667L414.667 595.333L414.333 594.667M506 594L507 595L506 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M514 594L515 595L514 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M406 595L407 596L406 595M514 595L515 596L514 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M405.333 596.667L405.667 597.333L405.333 596.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M413 596L414 597L413 596M507 596L508 597L507 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M515 596L516 597L515 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M413 597L414 598L413 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M507.333 597.667L507.667 598.333L507.333 597.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M515 597L516 598L515 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M405 598L406 599L405 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M413 598L414 599L413 598M516 598L517 599L516 598M404 599L405 600L404 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M412 599L413 600L412 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M508 599L509 600L508 599M516 599L517 600L516 599M404 600L405 601L404 600M412 600L413 601L412 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M508 600L509 601L508 600M517 600L518 601L517 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M404 601L405 602L404 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M412 601L413 602L412 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M509 601L510 602L509 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M517 601L518 602L517 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M403 602L404 603L403 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M411 602L412 603L411 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M509 602L510 603L509 602M518 602L521 605L518 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M403 603L404 604L403 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M411 603L412 604L411 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M510 603L511 604L510 603M518 603L519 604L518 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M402 604L403 605L402 604M411 604L412 605L411 604M510 604L511 605L510 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M519 604L520 605L519 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M402 605L403 606L402 605M410 605L411 606L410 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M511 605L512 606L511 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M520 605L521 606L520 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M401 606L402 607L401 606M410 606L411 607L410 606M511 606L512 607L511 606M521 606L522 607L521 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M401 607L402 608L401 607M409 607L410 608L409 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M512 607L513 608L512 607M521 607L522 608L521 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M400 608L401 609L400 608M409 608L410 609L409 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M513 608L514 609L513 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M521 608L522 609L521 608M400 609L401 610L400 609M408 609L409 610L408 609M514 609L516 611L514 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M521.333 609.667L521.667 610.333L521.333 609.667M399 610L400 611L399 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M408 610L409 611L408 610M514 610L515 611L514 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M520 610L521 611L520 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M522.667 610.333L523.333 610.667L522.667 610.333M398 611L396 614L398 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M407 611L408 612L407 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M516 611L518 613L516 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M517 611L518 613L519 613L520 611L517 611M524 611L525 612L524 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M525 611L526 612L525 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M398 612L399 613L398 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M407 612L408 613L407 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M526 612L527 613L526 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M527 612L528 613L527 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M397 613L398 614L397 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M406 613L407 614L406 613M517 613L518 614L517 613M528 613L529 614L528 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M394 614L395 615L394 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M395 614L396 615L395 614M405 614L406 615L405 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M406 614L407 615L406 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M516 614L517 615L516 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M529 614L530 615L529 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M530 614L531 615L530 614M392 615L393 616L392 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M393 615L394 616L393 615M405 615L406 616L405 615M515 615L516 616L515 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M531 615L532 616L531 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M532 615L533 616L532 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M391 616L392 617L391 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M392 616L393 617L392 616M405 616L417 628L405 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M406 616L407 617L406 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M514 616L515 617L514 616M533 616L534 617L533 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M534 616L536 618L534 616M389 617L390 618L389 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M390 617L391 618L390 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M407 617L408 618L407 617M513 617L514 618L513 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M534 617L535 618L534 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M387 618L388 619L387 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M388 618L389 619L388 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M408 618L409 619L408 618M512 618L508 623L512 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M536 618L537 619L536 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M537 618L538 619L537 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M386 619L387 620L386 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M409 619L410 620L409 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M512 619L513 620L512 619M521 619L522 620L521 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M519 623L524 620L519 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M524 619L525 620L524 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M538 619L539 620L538 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M539 619L540 620L539 619M384 620L385 621L384 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M385 620L386 621L385 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M410 620L411 621L410 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M511 620L512 621L511 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M256 782L660 782C660.572 754.295 667.509 720.337 649.211 696.04C643.821 688.882 633.552 684.731 626 680.2C609.057 670.034 591.942 660.166 575 650C562.724 642.634 550.281 635.554 538 628.2C534.238 625.947 527.635 620.07 523 620.878C517.794 621.786 513.42 629.44 509.989 633C499.025 644.378 488.889 656.55 478 668C474.487 671.694 469.514 680.226 464 680.824C458.125 681.462 450.747 670.67 447 667.015C436.031 656.315 424.851 645.851 414 635C410.29 631.29 405.311 624.026 400 622.736C395.272 621.588 388.815 627.136 385 629.397C373.047 636.48 361.017 643.45 349 650.424C331.964 660.312 315.113 670.525 298 680.281C290.818 684.375 278.96 688.79 273.843 695.379C269.305 701.223 268.059 711.947 266.151 719C260.569 739.638 256 760.56 256 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M525 620L526 621L525 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M526 620L527 621L526 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M540 620L541 621L540 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M382 621L383 622L382 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M383 621L384 622L383 621M397 621L398 622L397 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M398.667 621.333L399.333 621.667L398.667 621.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M400 621L401 622L400 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M411 621L412 622L411 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M510 621L511 622L510 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M526 621L527 622L526 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M527 621L528 622L527 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M541 621L542 622L541 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M542 621L543 622L542 621M380 622L379 624L380 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M381 622L382 623L381 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M395 622L396 623L395 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M396 622L397 623L396 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M401 622L402 623L401 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M412 622L413 623L412 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M509 622L510 623L509 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M528 622L529 623L528 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M529 622L530 623L529 622M543 622L544 623L543 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M544 622L545 623L544 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M380 623L381 624L380 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M394 623L395 624L394 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M395 623L396 624L395 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M402 623L403 624L402 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M413 623L414 624L413 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M508 623L509 624L508 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M518 623L519 624L518 623M530 623L531 624L530 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M531 623L532 624L531 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M545 623L546 624L545 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M377 624L378 625L377 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M378 624L379 625L378 624M392 624L393 625L392 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M393 624L394 625L393 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M403 624L404 625L403 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M414 624L415 625L414 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M507 624L508 625L507 624M517 624L518 625L517 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M531 624L532 625L531 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M532 624L533 625L532 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M546 624L547 625L546 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M547 624L548 625L547 624M375 625L376 626L375 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M376 625L377 626L376 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M390 625L391 626L390 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M391 625L392 626L391 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M404 625L405 626L404 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M415 625L416 626L415 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M506 625L507 626L506 625M516 625L517 626L516 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M533 625L534 626L533 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M534 625L535 626L534 625M548 625L549 626L548 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M549 625L550 626L549 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M374 626L375 627L374 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M375 626L376 627L375 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M389 626L390 627L389 626M405 626L406 627L405 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M416 626L417 627L416 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M505 626L506 627L505 626M515 626L516 627L515 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M535 626L537 628L535 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M536 626L537 627L536 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M550 626L551 627L550 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M551 626L553 628L551 626M372 627L373 628L372 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M373 627L374 628L373 627M387 627L388 628L387 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M388 627L389 628L388 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M406 627L407 628L406 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M417 627L418 628L417 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M504 627L505 628L504 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M514 627L510 632L514 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M537 627L538 628L537 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M551 627L552 628L551 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M370 628L371 629L370 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M371 628L372 629L371 628M385 628L386 629L385 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M386 628L387 629L386 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M407 628L408 629L407 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M418 628L419 629L418 628M503 628L504 629L503 628M514 628L515 629L514 628M538 628L539 629L538 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M539 628L540 629L539 628M553 628L554 629L553 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M554 628L555 629L554 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M369 629L370 630L369 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M383 629L384 630L383 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M384 629L385 630L384 629M408 629L409 630L408 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M419 629L420 630L419 629M502 629L503 630L502 629M513 629L514 630L513 629M540 629L542 631L540 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M541 629L542 630L541 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M555 629L556 630L555 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M556 629L557 630L556 629M367 630L368 631L367 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M368 630L369 631L368 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M382 630L383 631L382 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M383 630L384 631L383 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M409 630L410 631L409 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M420 630L421 631L420 630M501 630L497 635L501 630M512 630L513 631L512 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M542 630L543 631L542 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M556 630L557 631L556 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M557 630L558 631L557 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M365 631L366 632L365 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M366 631L367 632L366 631M380 631L381 632L380 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M381 631L382 632L381 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M410 631L411 632L410 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M421 631L422 632L421 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M501 631L502 632L501 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M511 631L512 632L511 631M543 631L544 632L543 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M544 631L545 632L544 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M558 631L559 632L558 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M559 631L560 632L559 631M363 632L364 633L363 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M364 632L365 633L364 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M378 632L379 633L378 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M379 632L380 633L379 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M411 632L412 633L411 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M422 632L423 633L422 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M500 632L501 633L500 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M510 632L511 633L510 632M545 632L546 633L545 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M546 632L547 633L546 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M560 632L561 633L560 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M561 632L562 633L561 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M362 633L363 634L362 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M363 633L364 634L363 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M377 633L378 634L377 633M412 633L413 634L412 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M423 633L424 634L423 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M499 633L500 634L499 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M509 633L510 634L509 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M547 633L548 634L547 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M548 633L549 634L548 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M562 633L563 634L562 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M360 634L361 635L360 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M361 634L362 635L361 634M375 634L376 635L375 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M376 634L377 635L376 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M413 634L414 635L413 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M424 634L425 635L424 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M498 634L499 635L498 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M508 634L509 635L508 634M548 634L549 635L548 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M549 634L550 635L549 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M563 634L564 635L563 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M564 634L565 635L564 634M358 635L359 636L358 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M359 635L360 636L359 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M373 635L374 636L373 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M374 635L375 636L374 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M414 635L415 636L414 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M425 635L426 636L425 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M497 635L498 636L497 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M507 635L508 636L507 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M550 635L551 636L550 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M551 635L552 636L551 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M565 635L566 636L565 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M566 635L567 636L566 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M357 636L358 637L357 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M371 636L372 637L371 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M372 636L373 637L372 636M415 636L416 637L415 636M426 636L427 637L426 636M496 636L497 637L496 636M506 636L507 637L506 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M552 636L554 638L552 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M553 636L554 637L553 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M567 636L568 637L567 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M355 637L356 638L355 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M356 637L357 638L356 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M370 637L371 638L370 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M371 637L372 638L371 637M416 637L417 638L416 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M427 637L428 638L427 637M495 637L496 638L495 637M505 637L506 638L505 637M554 637L555 638L554 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M568 637L569 638L568 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M569 637L570 638L569 637M353 638L354 639L353 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M354 638L355 639L354 638M368 638L369 639L368 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M369 638L370 639L369 638M417 638L418 639L417 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M428 638L429 639L428 638M494 638L495 639L494 638M504 638L505 639L504 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M555 638L556 639L555 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M556 638L557 639L556 638M570 638L571 639L570 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M571 638L572 639L571 638M351 639L352 640L351 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M352 639L353 640L352 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M366 639L367 640L366 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M367 639L368 640L367 639M418 639L419 640L418 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M429 639L430 640L429 639M493 639L494 640L493 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M503 639L500 643L503 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M557 639L558 640L557 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M558 639L559 640L558 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M572 639L573 640L572 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M573 639L575 641L573 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M350 640L351 641L350 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M351 640L352 641L351 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M365 640L366 641L365 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M419 640L420 641L419 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M430 640L431 641L430 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M492 640L493 641L492 640M503 640L504 641L503 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M559 640L560 641L559 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M573 640L574 641L573 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M348 641L349 642L348 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M349 641L350 642L349 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M363 641L364 642L363 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M364 641L365 642L364 641M420 641L421 642L420 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M431 641L432 642L431 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M491 641L492 642L491 641M502 641L503 642L502 641M560 641L561 642L560 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M561 641L562 642L561 641M575 641L576 642L575 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M576 641L577 642L576 641M346 642L347 643L346 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M347 642L348 643L347 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M361 642L362 643L361 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M362 642L363 643L362 642M421 642L422 643L421 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M432 642L433 643L432 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M490 642L487 646L490 642M501 642L502 643L501 642M562 642L563 643L562 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M563 642L564 643L563 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M577 642L578 643L577 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M578 642L580 644L578 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M345 643L346 644L345 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M359 643L360 644L359 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M360 643L361 644L360 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M422 643L423 644L422 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M433 643L434 644L433 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M490 643L491 644L490 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M500 643L501 644L500 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M564 643L565 644L564 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M578 643L579 644L578 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M343 644L344 645L343 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M344 644L345 645L344 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M358 644L359 645L358 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M359 644L360 645L359 644M423 644L424 645L423 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M434 644L435 645L434 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M489 644L490 645L489 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M499 644L500 645L499 644M565 644L566 645L565 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M566 644L567 645L566 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M580 644L581 645L580 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M581 644L582 645L581 644M341 645L342 646L341 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M342 645L343 646L342 645M356 645L357 646L356 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M357 645L358 646L357 645M424 645L425 646L424 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M435 645L436 646L435 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M488 645L489 646L488 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M498 645L499 646L498 645M567 645L568 646L567 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M568 645L569 646L568 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M582 645L583 646L582 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M583 645L584 646L583 645M339 646L338 648L339 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M340 646L341 647L340 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M354 646L355 647L354 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M355 646L356 647L355 646M425 646L426 647L425 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M436 646L437 647L436 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M487 646L488 647L487 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M497 646L498 647L497 646M569 646L570 647L569 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M570 646L571 647L570 646M583 646L584 647L583 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M584 646L585 647L584 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M339 647L340 648L339 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M353 647L354 648L353 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M354 647L355 648L354 647M426 647L441 662L426 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M427 647L428 648L427 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M437 647L438 648L437 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M486 647L487 648L486 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M496 647L497 648L496 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M570 647L571 648L570 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M571 647L572 648L571 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M585 647L586 648L585 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M586 647L587 648L586 647M336 648L337 649L336 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M337 648L338 649L337 648M351 648L352 649L351 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M352 648L353 649L352 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M428 648L429 649L428 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M438 648L439 649L438 648M485 648L486 649L485 648M495 648L496 649L495 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M572 648L573 649L572 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M573 648L574 649L573 648M587 648L588 649L587 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M588 648L589 649L588 648M334 649L335 650L334 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M335 649L336 650L335 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M349 649L350 650L349 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M350 649L351 650L350 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M429 649L430 650L429 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M439 649L440 650L439 649M484 649L485 650L484 649M494 649L495 650L494 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M574 649L576 651L574 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M575 649L576 650L575 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M589 649L590 650L589 649M333 650L334 651L333 650M348 650L349 651L348 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M430 650L431 651L430 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M440 650L441 651L440 650M483 650L484 651L483 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M493 650L489 655L493 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M576 650L577 651L576 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M590 650L591 651L590 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M591 650L592 651L591 650M331 651L332 652L331 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M332 651L333 652L332 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M346 651L347 652L346 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M347 651L348 652L347 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M431 651L432 652L431 651M441 651L442 652L441 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M482 651L483 652L482 651M493 651L494 652L493 651M577 651L578 652L577 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M578 651L579 652L578 651M592 651L593 652L592 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M593 651L594 652L593 651M329 652L330 653L329 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M330 652L331 653L330 652M344 652L345 653L344 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M345 652L346 653L345 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M432 652L433 653L432 652M442 652L444 654L442 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M443 652L444 653L443 652M481 652L482 653L481 652M492 652L493 653L492 652M579 652L581 654L579 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M580 652L581 653L580 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M594 652L595 653L594 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M595 652L597 654L595 652M327 653L326 655L327 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M328 653L329 654L328 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M342 653L343 654L342 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M343 653L344 654L343 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M433 653L434 654L433 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M480 653L476 658L480 653M491 653L492 654L491 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M581 653L582 654L581 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M595 653L596 654L595 653M327 654L328 655L327 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M341 654L342 655L341 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M342 654L343 655L342 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M434 654L435 655L434 654M444 654L458 668L444 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M445 654L446 655L445 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M480 654L481 655L480 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M490 654L491 655L490 654M582 654L583 655L582 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M583 654L584 655L583 654M597 654L598 655L597 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M598 654L599 655L598 654M324 655L325 656L324 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M325 655L326 656L325 655M339 655L340 656L339 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M340 655L341 656L340 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M435 655L436 656L435 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M446 655L447 656L446 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M479 655L480 656L479 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M489 655L490 656L489 655M584 655L586 657L584 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M585 655L586 656L585 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M599 655L600 656L599 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M600 655L602 657L600 655M322 656L323 657L322 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M323 656L324 657L323 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M337 656L338 657L337 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M338 656L339 657L338 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M436 656L437 657L436 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M447 656L448 657L447 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M478 656L479 657L478 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M488 656L489 657L488 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M586 656L587 657L586 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M600 656L601 657L600 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M321 657L322 658L321 657M336 657L337 658L336 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M337 657L338 658L337 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M437 657L438 658L437 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M448 657L449 658L448 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M477 657L478 658L477 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M487 657L488 658L487 657M587 657L588 658L587 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M588 657L589 658L588 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M602 657L603 658L602 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M603 657L604 658L603 657M319 658L320 659L319 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M320 658L321 659L320 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M334 658L335 659L334 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M335 658L336 659L335 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M438 658L439 659L438 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M449 658L450 659L449 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M476 658L477 659L476 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M486 658L487 659L486 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M589 658L590 659L589 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M590 658L591 659L590 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M604 658L605 659L604 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M605 658L606 659L605 658M317 659L318 660L317 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M318 659L319 660L318 659M332 659L333 660L332 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M333 659L334 660L333 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M439 659L440 660L439 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M450 659L451 660L450 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M475 659L476 660L475 659M485 659L486 660L485 659M591 659L592 660L591 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M605 659L606 660L605 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M606 659L607 660L606 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M315 660L314 662L315 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M316 660L317 661L316 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M330 660L331 661L330 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M331 660L332 661L331 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M440 660L441 661L440 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M451 660L452 661L451 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M474 660L475 661L474 660M484 660L485 661L484 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M592 660L593 661L592 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M593 660L594 661L593 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M607 660L608 661L607 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M608 660L609 661L608 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M315 661L316 662L315 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M329 661L330 662L329 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M330 661L331 662L330 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M441 661L442 662L441 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M452 661L453 662L452 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M473 661L474 662L473 661M483 661L484 662L483 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M594 661L595 662L594 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M595 661L596 662L595 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M609 661L610 662L609 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M610 661L611 662L610 661M312 662L313 663L312 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M313 662L314 663L313 662M327 662L328 663L327 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M328 662L329 663L328 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M442 662L443 663L442 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M453 662L454 663L453 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M472 662L473 663L472 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M482 662L478 667L482 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M596 662L597 663L596 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M597 662L598 663L597 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M611 662L612 663L611 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M310 663L311 664L310 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M311 663L312 664L311 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M325 663L326 664L325 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M326 663L327 664L326 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M443 663L444 664L443 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M454 663L455 664L454 663M471 663L472 664L471 663M482 663L483 664L482 663M597 663L598 664L597 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M598 663L599 664L598 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M612 663L613 664L612 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M613 663L614 664L613 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M309 664L310 665L309 664M324 664L325 665L324 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M325 664L326 665L325 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M444 664L445 665L444 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M455 664L456 665L455 664M470 664L471 665L470 664M481 664L482 665L481 664M599 664L600 665L599 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M600 664L601 665L600 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M614 664L615 665L614 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M615 664L616 665L615 664M307 665L308 666L307 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 665L309 666L308 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M322 665L323 666L322 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M323 665L324 666L323 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M445 665L446 666L445 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M456 665L457 666L456 665M469 665L465 670L469 665M480 665L481 666L480 665M601 665L603 667L601 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M602 665L603 666L602 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M616 665L617 666L616 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M305 666L306 667L305 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M306 666L307 667L306 666M320 666L321 667L320 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M321 666L322 667L321 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M446 666L447 667L446 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M457 666L458 667L457 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M469 666L470 667L469 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M479 666L480 667L479 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M603 666L604 667L603 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M617 666L618 667L617 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M618 666L619 667L618 666M303 667L302 669L303 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M304 667L305 668L304 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M318 667L319 668L318 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M319 667L320 668L319 667M447 667L448 668L447 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M458 667L459 668L458 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M468 667L469 668L468 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M478 667L479 668L478 667M604 667L605 668L604 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M605 667L606 668L605 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M619 667L620 668L619 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M620 667L621 668L620 667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M303 668L304 669L303 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M317 668L318 669L317 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M318 668L319 669L318 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M448 668L449 669L448 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M459 668L460 669L459 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M467 668L468 669L467 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M477 668L478 669L477 668M606 668L607 669L606 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M607 668L608 669L607 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M621 668L622 669L621 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M300 669L301 670L300 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M301 669L302 670L301 669M315 669L316 670L315 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M316 669L317 670L316 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M449 669L450 670L449 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M460 669L461 670L460 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M466 669L467 670L466 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M476 669L477 670L476 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M608 669L609 670L608 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M622 669L623 670L622 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M623 669L624 670L623 669M298 670L299 671L298 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M299 670L300 671L299 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M313 670L314 671L313 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M314 670L315 671L314 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M450 670L451 671L450 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M461 670L462 671L461 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M465 670L466 671L465 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M475 670L476 671L475 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M609 670L610 671L609 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M610 670L611 671L610 670M624 670L625 671L624 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M625 670L626 671L625 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M297 671L298 672L297 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M298 671L299 672L298 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M312 671L313 672L312 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M313 671L314 672L313 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M451 671L452 672L451 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M462 671L463 672L462 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M464 671L465 672L464 671M474 671L475 672L474 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M611 671L612 672L611 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M612 671L613 672L612 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M626 671L627 672L626 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M627 671L629 673L627 671M295 672L296 673L295 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M296 672L297 673L296 672M310 672L311 673L310 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M311 672L312 673L311 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M452 672L453 673L452 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M463 672L464 673L463 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M473 672L474 673L473 672M613 672L614 673L613 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M627 672L628 673L627 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M293 673L294 674L293 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M294 673L295 674L294 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M308 673L309 674L308 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M309 673L310 674L309 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M453 673L454 674L453 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M472 673L468 678L472 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M614 673L615 674L614 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M615 673L616 674L615 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M629 673L630 674L629 673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M630 673L631 674L630 673M291 674L290 676L291 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M292 674L293 675L292 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M306 674L307 675L306 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M307 674L308 675L307 674M454 674L455 675L454 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M472 674L473 675L472 674M616 674L617 675L616 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M617 674L618 675L617 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M631 674L632 675L631 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M632 674L634 676L632 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M291 675L292 676L291 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M305 675L306 676L305 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M306 675L307 676L306 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M455 675L456 676L455 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M471 675L472 676L471 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M618 675L619 676L618 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M632 675L633 676L632 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M288 676L289 677L288 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M289 676L290 677L289 676M303 676L304 677L303 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M304 676L305 677L304 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M456 676L457 677L456 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M470 676L471 677L470 676M619 676L620 677L619 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M620 676L621 677L620 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M634 676L635 677L634 676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M635 676L636 677L635 676M286 677L287 678L286 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M287 677L288 678L287 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M301 677L302 678L301 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M302 677L303 678L302 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M457 677L458 678L457 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M469 677L470 678L469 677M621 677L622 678L621 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M622 677L623 678L622 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M636 677L637 678L636 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M637 677L639 679L637 677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M285 678L286 679L285 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M286 678L287 679L286 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M300 678L301 679L300 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M301 678L302 679L301 678M458 678L459 679L458 678M468 678L469 679L468 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M623 678L624 679L623 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M624 678L625 679L624 678M637 678L638 679L637 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M283 679L284 680L283 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M284 679L285 680L284 679M298 679L299 680L298 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M299 679L300 680L299 679M459 679L460 680L459 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M466 679L465 681L466 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M467 679L468 680L467 679M624 679L625 680L624 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M625 679L626 680L625 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M639 679L640 680L639 679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M640 679L641 680L640 679M281 680L282 681L281 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M282 680L283 681L282 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M296 680L297 681L296 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M297 680L298 681L297 680M460 680L461 681L460 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M461 680L462 681L461 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M466 680L467 681L466 680M626 680L627 681L626 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M627 680L628 681L627 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M641 680L642 681L641 680z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M642 680L643 681L642 680M279 681L278 683L279 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M280 681L281 682L280 681M295 681L296 682L295 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M462 681L462 682L465 682L462 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M628 681L629 682L628 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M629 681L630 682L629 681M642 681L643 682L642 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M643 681L644 682L643 681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M279 682L280 683L279 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M293 682L294 683L293 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M294 682L295 683L294 682M629 682L630 683L629 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M630 682L631 683L630 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M644 682L645 683L644 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M645 682L646 683L645 682M276 683L277 684L276 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M277 683L278 684L277 683M291 683L292 684L291 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M292 683L293 684L292 683M631 683L632 684L631 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M632 683L633 684L632 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M646 683L647 684L646 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M647 683L649 685L647 683M274 684L273 686L274 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M275 684L276 685L275 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M289 684L290 685L289 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M290 684L291 685L290 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M633 684L634 685L633 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M634 684L635 685L634 684M647 684L648 685L647 684M274 685L275 686L274 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M288 685L289 686L288 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M289 685L290 686L289 685M634 685L635 686L634 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M635 685L636 686L635 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M649 685L650 686L649 685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M650 685L651 686L650 685M271 686L272 687L271 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M272 686L273 687L272 686M286 686L287 687L286 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M287 686L288 687L287 686M636 686L637 687L636 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M637 686L638 687L637 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M651 686L652 687L651 686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M269 687L268 689L269 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M270 687L271 688L270 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M284 687L285 688L284 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M285 687L286 688L285 687M638 687L640 689L638 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M639 687L640 688L639 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M652 687L653 688L652 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M269 688L270 689L269 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M283 688L284 689L283 688M640 688L641 689L640 688M653 688L654 689L653 688M267 689L268 690L267 689M281 689L282 690L281 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M282 689L283 690L282 689M641 689L642 690L641 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M642 689L643 690L642 689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M654 689L656 691L654 689M266 690L267 691L266 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M279 690L280 691L279 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M280 690L281 691L280 690M643 690L645 692L643 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M644 690L645 691L644 690M654 690L655 691L654 690M266 691L267 692L266 691M277 691L278 692L277 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M278 691L279 692L278 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M645 691L646 692L645 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M655 691L656 692L655 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M265 692L266 693L265 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M276 692L277 693L276 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M277 692L278 693L277 692M646 692L648 694L646 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M647 692L648 693L647 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M656 692L658 694L656 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M265 693L266 694L265 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M274 693L275 694L274 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M275 693L276 694L275 693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M656 693L657 694L656 693M265 694L266 695L265 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M273 694L274 695L273 694M648 694L649 695L648 694M657 694L658 695L657 694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M264 695L265 696L264 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M272 695L273 696L272 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M649 695L650 696L649 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M658 695L659 696L658 695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M264 696L265 697L264 696M272 696L273 697L272 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M649 696L651 698L649 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M650 696L651 697L650 696M658 696L659 697L658 696M264 697L265 698L264 697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M272 697L273 698L272 697M659 697L660 698L659 697M263.333 698.667L263.667 699.333L263.333 698.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M271 698L272 699L271 698M651 698L652 699L651 698M659 698L660 699L659 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M271 699L272 700L271 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M651 699L652 700L651 699M660 699L661 700L660 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M263 700L264 701L263 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M271 700L272 701L271 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M652 700L653 701L652 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M660 700L661 701L660 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M262.333 701.667L262.667 702.333L262.333 701.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M270 701L271 702L270 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M652 701L653 702L652 701M661 701L662 702L661 701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M270 702L271 703L270 702M653 702L654 703L653 702M661 702L662 703L661 702M262 703L263 704L262 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M270 703L271 704L270 703M653 703L654 704L653 703M662 703L663 704L662 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M262 704L263 705L262 704M269 704L270 705L269 704M654 704L655 705L654 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M662 704L663 705L662 704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M261 705L262 706L261 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M269 705L270 706L269 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M654 705L655 706L654 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M662 705L663 706L662 705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M261 706L262 707L261 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M269.333 706.667L269.667 707.333L269.333 706.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M655 706L656 707L655 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M663 706L664 707L663 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M261 707L262 708L261 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M655 707L656 708L655 707M663 707L664 708L663 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M260.333 708.667L260.667 709.333L260.333 708.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M268 708L269 709L268 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M655 708L656 709L655 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M663 708L664 709L663 708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M268 709L269 710L268 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M656 709L657 710L656 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M664 709L665 710L664 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M260 710L261 711L260 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M268 710L269 711L268 710M656.333 710.667L656.667 711.333L656.333 710.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M664 710L665 711L664 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M267 711L268 712L267 711M664 711L665 712L664 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M259 712L260 713L259 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M267 712L268 713L267 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M657 712L658 713L657 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M665 712L666 713L665 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M259 713L260 714L259 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M267.333 713.667L267.667 714.333L267.333 713.667M657.333 713.667L657.667 714.333L657.333 713.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M665 713L666 714L665 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M259 714L260 715L259 714M665 714L666 715L665 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M258.333 715.667L258.667 716.333L258.333 715.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M266 715L267 716L266 715M658 715L659 716L658 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M266 716L267 717L266 716M658 716L659 717L658 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M666 716L667 717L666 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M258 717L259 718L258 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M266 717L267 718L266 717M658.333 717.667L658.667 718.333L658.333 717.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M666 717L667 718L666 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M258 718L259 719L258 718M265 718L266 719L265 718M666.333 718.667L666.667 719.333L666.333 718.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M257 719L258 720L257 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M265 719L266 720L265 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M659 719L660 720L659 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M257 720L258 721L257 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M265.333 720.667L265.667 721.333L265.333 720.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M659 720L660 721L659 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M667.333 720.667L667.667 721.333L667.333 720.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M257 721L258 722L257 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M659.333 721.667L659.667 722.333L659.333 721.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M264 722L265 723L264 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M667 722L668 723L667 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M256 723L257 724L256 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M264 723L265 724L264 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M660.333 723.667L660.667 724.333L660.333 723.667M667.333 723.667L667.667 724.333L667.333 723.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M256 724L257 725L256 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M264.333 724.667L264.667 725.333L264.333 724.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M256 725L257 726L256 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M660 725L661 726L660 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M668 725L668 728L669 728L668 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M263 726L264 727L263 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M660 726L660 729L661 729L660 726M255 727L256 728L255 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M263 727L264 728L263 727M255 728L256 729L255 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M263.333 728.667L263.667 729.333L263.333 728.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M668 728L669 729L668 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M255 729L256 730L255 729M668 729L668 732L669 732L668 729M262 730L263 731L262 730M661.333 730.667L661.667 731.333L661.333 730.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M254 731L255 732L254 731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M262 731L263 732L262 731M254 732L255 733L254 732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M262.333 732.667L262.667 733.333L262.333 732.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M661.333 732.667L661.667 733.333L661.333 732.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M254.333 733.667L254.667 734.333L254.333 733.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M669 733L669 737L670 737L669 733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M261 734L262 735L261 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M661 734L661 738L662 738L661 734M253.333 735.667L253.667 736.333L253.333 735.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M261 735L262 736L261 735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M261.333 736.667L261.667 737.333L261.333 736.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M253 737L254 738L253 737M669 737L669 740L670 740L669 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M253 738L254 739L253 738M260.333 738.667L260.667 739.333L260.333 738.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M252.333 740.667L252.667 741.333L252.333 740.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M260 740L261 741L260 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M662 740L662 748L663 748L662 740M669 740L669 747L670 747L669 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M260.333 741.667L260.667 742.333L260.333 741.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M252 742L253 743L252 742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M252 743L253 744L252 743M259.333 743.667L259.667 744.333L259.333 743.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M251.333 745.667L251.667 746.333L251.333 745.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M259 745L260 746L259 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M259.333 746.667L259.667 747.333L259.333 746.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M251 747L252 748L251 747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M251 748L252 749L251 748M258.333 748.667L258.667 749.333L258.333 748.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M662 748L662 754L663 754L662 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M250.333 750.667L250.667 751.333L250.333 750.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M258 750L259 751L258 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M258.333 751.667L258.667 752.333L258.333 751.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M250.333 752.667L250.667 753.333L250.333 752.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M250 754L251 755L250 754M257.333 754.667L257.667 755.333L257.333 754.667M662 754L662 762L663 762L662 754M669 754L669 762L670 762L669 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M249 756L249 759L250 759L249 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M257 756L258 757L257 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M257.333 757.667L257.667 758.333L257.333 757.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M249 759L250 760L249 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M249 760L249 763L250 763L249 760M256.333 761.667L256.667 762.333L256.333 761.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M669 762L669 765L670 765L669 762M256.333 763.667L256.667 764.333L256.333 763.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M248 764L248 767L249 767L248 764M256 765L256 768L257 768L256 765M661 765L661 769L662 769L661 765M669 765L669 769L670 769L669 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M248 767L248 770L249 770L248 767M661.333 769.667L661.667 770.333L661.333 769.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M248 770L248 775L249 775L248 770M255 770L255 775L256 775L255 770M661 771L661 774L662 774L661 771M668 771L668 774L669 774L668 771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M668.333 774.667L668.667 775.333L668.333 774.667M255 775L255 782L256 782L255 775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M660 775L660 778L661 778L660 775M668 776L668 779L669 779L668 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M660 778L661 779L660 778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M660.333 779.667L660.667 780.333L660.333 779.667M667.333 780.667L667.667 781.333L667.333 780.667M255 782L256 783L255 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M256 782L256 783L660 783L624 782L542 782L256 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M667 782L668 783L667 782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M667.333 783.667L667.667 784.333L667.333 783.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M248 784L248 787L249 787L248 784M666 786L667 787L666 786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M248 787L249 788L248 787M666 787L667 788L666 787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M248 788L250 790L248 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M249 788L250 789L249 788M665 788L666 789L665 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M666 788L667 789L666 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M250 789L251 790L250 789M664 789L665 790L664 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M665 789L666 790L665 789M251 790L251 791L664 791C654.211 786.892 637.634 790 627 790L543 790L251 790z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestUp);
export default __webpack_public_path__ + "static/media/chest-up.9e8716a4da229c694685cb748ecd7bb6.svg";
export { ForwardRef as ReactComponent };